import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const HowApc = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">
    How to apply for an APC Discount/Waiver?
    </h2>
    <hr />

    <p className="joab-common-para my-4">
    To request an <span className="fw-bold">APC Waiver Application Form</span>, contact info@iournalofappliedbioanalysis.com. Requests for APC Waiver and discounts will be considered on a case-by-case basis and may be granted in cases of financial need.  All APC Discount/Waiver applications have to be made prior to or at the point of manuscript submission; requests made during the review process or after acceptance will not be considered.
    </p>
   
  </Container>
  );
};

export default HowApc;
